<template>
  <div class="routine-finder-commerce-connector">
    <div class="routine-finder-commerce-connector__cta">
      <button v-truncate-rich-text="{ limit: 12, ellipse: false, singleLine: true }" @click.stop="openRetailer()"
        class="buyBtn">{{ ctaLable }}</button>
    </div>
    <div class="commerce-connector" @click.stop>
      <div class="popupContainerOuter-overlay" :class="{ 'showPopup': showPopup }"></div>
      <div class="popupContainerOuter popupWrapper" id="popupContainerOuter" :class="{ 'showPopup': showPopup }">

        <div class="popupRetailer">
          <div class="popup-title__container">
            <h2 class="popup-heading"> <span v-if="enableSoringDatas">{{retailerDatas.buyOnline}}</span></h2>
            <button class="popupCLose" @click="closePopupScreen()"></button>
          </div>
          <h3 class="popup-slectShop" v-if="enableSoringDatas">{{retailerDatas.selectShop}}</h3>

          <div class="retailer-sorting__container" v-if="enableSoringDatas">

            <customSorting ref="retailer_sorting"  :sortlabel="retailerDatas.sortBy" :options="retailerDatas.sortByOptions" :default="retailerDatas.defaultText" class="select"
              @getInput="sortOrder = $event" />
          </div>
          <div class="tabs">
            <ul>
              <li v-for="(tab, index) in this.eretailer" :class="{ 'is-active': show == index }"
                @click.prevent="show = index" :key="index">
                {{ tab.countryCode }}
              </li>
            </ul>
          </div>

          <div class="tabData">

            <transition-group name="fade-up" target="div" appear @click.native="navigate($event)">

              <div v-for="(tab, index) in this.eretailer" v-if="show == index" :key="index">

                <div class="retailer-count" v-if="tab.enableBuynowSortOption && tab.shopsUnavailable==false">{{ tab.shops.length }} {{retailerDatas.onlineShoping}}</div>
                <div id="commerceConnectWrapper" v-if="tab.shopsUnavailable == false">
                  <div>
                    <div class="retailer-shop__container" v-for="shop in sortedItems" :key="shop.id">
                      <div class="retailer-shop-wrapper">
                        <div class="retailer-shop-img">
                          <img :src="shop.logo" alt="shop" width="130" height="70" class="" />
                        </div>
                        <div class="retailer-shop-name-wrapper">
                          <span class="retailer-name"> {{ shop.title }} </span>
                          <span class="retailer-price" v-if="shop.price"> {{shop.price}}</span>
                        </div>
                      </div>
                      <div class="retailer-shop-instock" v-if="shop.stockAvailability">
                       {{shop.stockAvailability}}
                      </div>
                      <div class="retailer-shop-deliveryTime" v-if="shop.deliveryTime">
                        {{retailerDatas.deliveryTimeLabel}}<strong> {{shop.deliveryTime}}</strong>
                      </div>
                      <div class="retailer-shop-buyNow">
                        <a :href="shop.link" @click="setAnalytics(shop.cartTagging)" target="_blank"
                          class="cta cta--light" panel-focusable=""> {{ shop.buyButton }}</a>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="popupContainer__inner" id="commerceConnectWrapper" v-else>
                  {{ tab.defaultDescriptionTitle }}
                </div>
              </div>
            </transition-group>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {
  AnalyticsHandler
} from '@Foundation/analyticsHandler';
import {
  truncateRichText
} from '@Foundation/directives/truncateRichText/truncateRichText';
import customSorting from '@Feature/CustomSorting/custom-sorting.vue';

export default {
  name: 'routine-finder-commerce-connector',
  components: {
    customSorting
  },
  directives: {
    truncateRichText
  },
  props: {
    eretailer: {
      type: Object,
      default: []
    },
    ctaLable: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      sortField:'title',
      settings: {
        'dots': true,
        'arrows': true,
        'infinite': false,
        'speed': 500,
        'slidesToShow': 4,
        'slidesToScroll': 4,
        'initialSlide': 0,
        'touchThreshold': 5,
        'responsive': [{
          'breakpoint': 1024,
          'settings': {
            'slidesToShow': 4,
            'slidesToScroll': 4,
            'infinite': false,
            'dots': true
          }
        },
        {
          breakpoint: 1023,
          settings: {
            'slidesToShow': 1,
            'slidesToScroll': 1,
            'dots': true,
            'arrows': true,
          }
        },
        {
          breakpoint: 768,
          settings: {
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 0,
            speed: 15000,
            cssEase: 'linear',
            infinite: true,
            arrows: false,
            touchMove: true,
            swipeToSlide: true,
            swipe: true
          }
        },
        ]
      },
      showPopup: false,
      show: 0,
      smallScreen: !window.matchMedia('(min-width: 1024px)').matches,
      currentSlide: 0, // Track the current slide
      totalSlides: 0, // Track total slides
      sliderAtEnd: true,
      sliderAtBegin: false,
      selectedInput: '',
      sortOrder: '',
      retailerDatas: this.eretailer[0]?.retailerDictionaryDatas,
      enableSoringDatas: this.eretailer[0]?.enableBuynowSortOption,

    };
  },
  watch: {
    showPopup(newValue) {
      if (newValue) {
        this.sortOrder = '';
        this.$refs.retailer_sorting.selected = this.retailerDatas.defaultText;

      }
    }
  },
  computed: {
    sortedItems() { 
      if (!this.sortOrder) return this.eretailer[this.show].shops;
      return [...this.eretailer[this.show].shops].sort((a, b) => {
        if (this.sortOrder === 'asc') {
          return a[this.sortField].localeCompare(b[this.sortField]);
        } else {
          return b[this.sortField].localeCompare(a[this.sortField]);
        }
      });
    }
  },
  methods: {
    goToPrevSlide() {
      this.$refs.carousel[0].prev(); // Go to the previous slide
      const activeButton = this.$el.querySelector('.slick-dots .slick-active button');
      const activeSlideValue = parseInt(activeButton.textContent.trim());
      if (activeSlideValue === 1) {
        this.sliderAtBegin = false;
        this.sliderAtEnd = true;
      }
    },
    goToNextSlide() {
      this.sliderAtBegin = true;
      this.$refs.carousel[0].next(); // Go to the next slide
      if (this.$el.querySelectorAll('.slick-dots li')) {
        const totalCount = this.$el.querySelectorAll('.slick-dots li').length;
        const activeButton = this.$el.querySelector('.slick-dots .slick-active button');
        const activeSlideValue = parseInt(activeButton.textContent.trim());
        if (parseInt(totalCount) <= activeSlideValue) {
          this.sliderAtEnd = false;
        }
      }
    },
    openRetailer() {  
      this.showPopup = true;
    },
    closePopupScreen() { 
      this.showPopup = false;
    },
    setAnalytics(dataObject) {
      AnalyticsHandler.pushDataLayer(dataObject);
    },

  },

};
</script>

<style lang="scss" src="./routine-finder-commerce-connector.scss"></style>
<style lang="scss" src="../../../../../LrpRetailer/code/Scripts/components/lrp-retailer.scss"></style>
